module.exports = __webpack_public_path__ + "static/LemonBird-Regular-622035b2d0abd7dc89231a1f06e5dfd9.woff2";